import React from "react";
import { useTranslation } from "react-i18next";
import U2000ActionBtn from "../../../../u2000Core/components/buttons/U2000ActionBtn";
import U2000ResponsiveToolbar from "../../../../u2000Core/components/toolbar/U2000ResponsiveToolbar";
import { FaEye, FaPlus, FaRegFile, FaTrashAlt } from "react-icons/fa";
import { useU2000AuthContext } from "../../../../u2000Core/context/auth/U2000UseAuthContext";
import type { U2000FormStateHandlers } from "../../../../u2000Core/reducer/formReducer/U2000FormStateHandlers";
import { U2000FormStateEnumState } from "../../../../u2000Core/reducer/formReducer/U2000FormState";
import { NS, U2103ROLES } from "../../../U2103";
import { TbLockPassword } from "react-icons/tb";

interface U2103UserFormStateHandlers extends U2000FormStateHandlers<any> {
  getData: () => any;
  getFormState: () => U2000FormStateEnumState;
  addNewUser: () => void;
  modifyUser: () => void;
  deleteUser: () => void;
}

interface U2103UserFormBtnsComponentProps {
  formStateHandlers: U2103UserFormStateHandlers;
}

export const U2103UserFormToolBar: React.FC<U2103UserFormBtnsComponentProps> = ({ formStateHandlers }) => {
  const formState = formStateHandlers.getFormState();
  const ssoEnabled = formStateHandlers.getData()?.ssoEnabled === true;

  const { hasRole } = useU2000AuthContext();
  const { t } = useTranslation();

  const actions = [
    {
      key: "add",
      label: t("btnAdd", { ns: NS }),
      hasRole: hasRole(U2103ROLES.ADD),
      handleClick: () => {
        formStateHandlers.addNewUser();
      },
      disabled: formState === U2000FormStateEnumState.EDIT,
      icon: FaPlus,
      Component: U2000ActionBtn,
    },
    {
      key: "modify",
      label: t("btnModify", { ns: NS }),
      hasRole: hasRole(U2103ROLES.EDIT),
      handleClick: () => {
        formStateHandlers.modifyUser();
      },
      disabled: formState === U2000FormStateEnumState.EDIT,
      icon: FaRegFile,
      Component: U2000ActionBtn,
    },
    {
      key: "delete",
      label: t("btnDelete", { ns: NS }),
      hasRole: hasRole(U2103ROLES.DELETE),
      handleClick: () => {
        formStateHandlers.deleteUser();
      },
      disabled: formState === U2000FormStateEnumState.EDIT,
      icon: FaTrashAlt,
      Component: U2000ActionBtn,
    },
    {
      key: "resetPwd",
      label: t("btnResetPwd", { ns: NS }),
      hasRole: hasRole(U2103ROLES.RESETPASSWORD) && !ssoEnabled,
      handleClick: () => {
        formStateHandlers.resetPassword();
      },
      disabled: formStateHandlers.getFormState() === U2000FormStateEnumState.EDIT || formStateHandlers.getData().active === false,
      icon: TbLockPassword,
      Component: U2000ActionBtn,
    },
    {
      key: "showSecretKey",
      label: t("btnShowSecretKey", { ns: NS }),
      hasRole: hasRole(U2103ROLES.VIEWSECRETKEY) && !ssoEnabled,
      handleClick: () => {
        formStateHandlers.showSecretKey();
      },
      disabled: formStateHandlers.getFormState() === U2000FormStateEnumState.EDIT || formStateHandlers.getData().active === false,
      icon: FaEye,
      Component: U2000ActionBtn,
    },
  ];

  return <U2000ResponsiveToolbar actions={actions} />;
};
